export default "__VITE_ASSET__532a9a22__"